'use client'

import { INoticeEvent } from '@/api/interfaces/INoticeEvent'
import { createT } from '@/locales/index'
import { WithT } from '@/locales/types'
import { formatDate, fromNow } from '@/util/datetime'
import dayjs from 'dayjs'
import Image from 'next/image'
import Link from 'next/link'
import { useMemo } from 'react'

type Props = {
  event: INoticeEvent.IEvent.IEventR
}

export function EventRow({ event, translations }: WithT<Props>) {
  const t = createT(translations)

  const date = useMemo(() => {
    const today = new Date()
    const startDate = new Date(event.startDate!)
    const endDate = new Date(event.endDate!)

    const diffDays = Math.floor(dayjs(today).diff(dayjs(endDate), 'day', true))

    return (
      <div className="flex items-center gap-1">
        {diffDays >= 0 ? (
          <span className="font-bold text-gray-500 text-body3">
            {t('closed')}
          </span>
        ) : (
          <span className="font-bold text-key text-body3">D{diffDays}</span>
        )}

        <div className="text-body3 text-gray-600" suppressHydrationWarning>
          {formatDate(event.startDate)} ~ {formatDate(event.endDate)}
        </div>
      </div>
    )

    // return (
    //   <div className="text-body3 text-gray-600" suppressHydrationWarning>
    //     {fromNow(event.createDate, translations)}
    //   </div>
    // )
  }, [event, translations])

  return (
    <Link
      href={`/notice/${event.id}?type=EVENT`}
      className="flex items-center gap-2 py-4"
    >
      <div className="flex flex-col gap-1.5 flex-1">
        <div className="text-body3 font-bold text-gray-600">
          <span>{t('event')}</span>
        </div>
        <p className="text-body2 font-bold">{event.title}</p>
        {date}
      </div>
      {event.thumbnailUrl && (
        <Image
          src={event.thumbnailUrl}
          alt={event.title}
          width={100}
          height={60}
          className="h-[3.75rem] rounded object-cover"
        />
      )}
    </Link>
  )
}
